import { render } from "./SimpleSecretSelector.vue?vue&type=template&id=faf062d8"
import script from "./SimpleSecretSelector.vue?vue&type=script&lang=js"
export * from "./SimpleSecretSelector.vue?vue&type=script&lang=js"

import "./SimpleSecretSelector.vue?vue&type=style&index=0&id=faf062d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__